import React from "react";
import "../../styles/SalesFunnel.css";
import { Link } from "react-router-dom";
import BAservice from "../../Page-section/business-automation/BAservice";
import Faq from "../../Page-section/business-automation/Faq";
import {
  FaLightbulb,
  FaUsers,
  FaCode,
  FaCogs,
  FaAward,
  FaPaperPlane,
} from "react-icons/fa";
import Portfolio from "../../components/portfolio";

const BAprocess = () => {
  const points = [
    " Reduces guide workload ",
    "Improves operational efficiency ",
    "Enhances accuracy and consistency ",
    "Saves time and operational expenses ",
    "Enables faster decision-making ",
  ];
  const point = [
    "Increased Productivity",
    "Cost Efficiency",
    "Better Accuracy",
    "Faster Processes",
    "Scalability",
  ];

  const steps = [
    {
      id: 1,
      title: "Analysis & Consultation",
      color: "green",

      icon: <FaLightbulb />,
      desc: "We apprehend your enterprise requirements and become aware of regions where technique automation can be applied.",
    },
    {
      id: 2,
      title: "Strategy Development",
      color: "#0868a0",
      icon: <FaUsers />,
      desc: "Our experts create a custom designed plan to automate business approaches based totally on your dreams.",
    },
    {
      id: 3,
      title: " Implementation",
      color: "green",
      icon: <FaCode />,
      desc: "We installation automation equipment and systems tailored on your business desires.",
    },
    {
      id: 4,
      title: "Testing & Optimization",
      color: "#0868a0",
      icon: <FaCogs />,
      desc: "We make certain the entirety works seamlessly and optimize overall performance for higher consequences.",
    },
    {
      id: 5,
      title: " Launch",
      color: "green",
      icon: <FaAward />,
      desc: "We thoroughly test the before launching it.",
    },
    {
      id: 6,
      title: "Ongoing Support",
      color: "#0868a0",
      icon: <FaPaperPlane />,
      desc: "As a depended on provider of commercial enterprise automation offerings in noida, we provide non-stop guide and upgrades.",
    },
  ];
  return (
    <section className="sf-wrapper">
      <div className="sf-sidebar">
      <div className="sf-card">
          <h2>Our Services</h2>

          <ul className="sf-service-list"> 
               <li className="active">
              <Link to="/business-automation-services">
                Business Automation
              </Link>
            </li>
            <li>
              <Link to="/web-development-company-in-noida">Web Development</Link>
            </li>
            <li>
              <Link to="/web-design-services">Web Design</Link>
            </li>
            <li>
              <Link to="/seo-agency-noida">SEO Services</Link>
            </li>
               <li>
              <Link to="/social-media-marketing-services">Social Media Marketing</Link>
            </li>
            <li>
              <Link to="/content-marketing-services">Content Marketing</Link>
            </li>
            <li>
              <Link to="/ai-automation-services">
                AI Automation Services
              </Link>
            </li>
          
            <li>
              <Link to="/lead-generation-services">Lead Generation</Link>
            </li>
            <li>
              <Link to="/sales-funnel-optimization">
                Sales Funnel Optimization
              </Link>
            </li>
            <li>
              <Link to="/branding-agency-noida">Branding Services</Link>
            </li>
         
            <li>
              <Link to="/resources">Resources</Link>
            </li>
          </ul>
        </div>

        <div className="sf-card">
          <h2>Contact Info</h2>

          <div className="sf-contact">
            <p>Address :- Sector-62, Noida, India</p>
            <p>
              Phone :- <br />
              <a href="tel:+918368327503"> +91 8368327503</a> |{" "}
              <a href="tel:+919319563429"> +91 9319563429</a>
            </p>
            <p>
              Email :- <br />
              <a href="mailto:connect@empowerweb.in">connect@empowerweb.in</a>
            </p>
          </div>
        </div>
                <Portfolio />

      </div>
      <div className="sf-main-content">
        <section className="freight-container">
          <div className="freight-content">
            <h3>What is Business Automation?</h3>
            <p>
              Business automation refers to using era to perform obligations
              with minimal human intervention. It involves automating ordinary
              operations together with records entry, electronic mail responses,
              customer service, and workflow management.
            </p>

            <p>
              The foremost aim is to <b>automate business processes </b> in
              order that teams can awareness on high-fee activities like
              approach, innovation, and consumer revel in. By integrating
              automation into your commercial enterprise, you could attain
              higher productivity and long-time period increase.
            </p>
          </div>
        </section>
        <section className="why-container">
          <div className="why-content">
            <h2>Why Your Business Needs Automation</h2>

            <p>
              Manual approaches aren't most effective time-eating however also
              prone to mistakes. Implementing <b>process automation </b>{" "}
              companies to streamline operations and gain better consequences
              with less effort. Here are some key reasons why automation is
              vital:
            </p>

            <ul>
              {points.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>

            <p>
              With the right business automation services in noida, businesses
              can eliminate inefficiencies and enhance universal overall
              performance.
            </p>
          </div>
        </section>

        <BAservice />
        <section className="work-process-section">
          <h3 className="work-title">Our Process for Business Automation</h3>
          <p className="work-subtitle">
            We follow a based method to supply effective{" "}
            <b>business automation services</b>:
          </p>

          <div className="process-wrapper">
            {/* STEP LABELS */}
            <div className="process-line">
              {steps.map((step) => (
                <div
                  key={step.id}
                  className="process-step"
                  style={{ backgroundColor: step.color }}
                >
                  {step.title}
                </div>
              ))}
            </div>

            {/* STEP DETAILS */}
            <div className="process-grid">
              {steps.map((step) => (
                <div className="process-item" key={step.id}>
                  <div
                    className="process-iconv"
                    style={{ borderColor: step.color, color: step.color }}
                  >
                    {step.icon}
                  </div>
                  <h3 className="process-num" style={{ color: step.color }}>
                    {step.id.toString().padStart(2, "0")}
                  </h3>
                  <p className="process-text">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="why-container">
          <div className="why-content">
            <h2>Benefits of Business Automation</h2>
            <p>
              Implementing business automation offers numerous advantages that
              directly impact your business growth:
            </p>
            <ul>
              {point.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>
          </div>
        </section>
        <section className="benefits-section">
          <div className="container">
            <div className="header">
              <div className="title-row">
                <h3>Why Choose Us?</h3>

                <p>
                  Choosing the right partner for business automation services is
                  essential for success. Here’s why businesses trust us:
                </p>
              </div>
            </div>

            <div className="cards">
              <div className="card">
                <h3>Expertise in business automation solutions </h3>
              </div>
              <div className="card">
                <h3>Customized strategies for different industries </h3>
              </div>
              <div className="card">
                <h3>Affordable and scalable solutions </h3>
              </div>
              <div className="card">
                <h3>Proven track record of success </h3>
              </div>
              <div className="card">
                <h3>Dedicated support team </h3>
              </div>
            </div>
          </div>
        </section>
        <Faq />
        <section className="operations-wrapper">
          <div className="operations-left">
            <h3>Get Started with Business Automation Today</h3>
          </div>
          <div className="operations-right">
              <p>
                If you are looking to streamline your operations and improve
                efficiency, now is the time to invest in{" "}
                <b>business automation services in noida</b>. Our expert team is
                here to help you transform your business with advanced
                automation solutions.
              </p>
          </div>
        </section>
      </div>
    </section>
  );
};

export default BAprocess;
